import React, { useState, useEffect } from 'react';
import Spiner from '../Components/Admin/Spiner/Spiner';
import { Outlet } from 'react-router-dom';
import Auth from '../Components/Admin/Auth/Auth';
import baseURL from '../Components/url';

export default function MainLayout() {
    const [usuario, setUsuario] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${baseURL}/userLogued.php`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setUsuario(data);
                setLoading(false);
            } catch (error) {
                console.error('Error al obtener datos de usuario logueado:', error);
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const rolesAutorizados = ['admin', 'mesero', 'cocinero', 'cajero'];
    const tienePermiso = usuario.idUsuario && rolesAutorizados.includes(usuario.rol?.toLowerCase());

    return (
        <div>
            {loading ? (
                <Spiner />
            ) : tienePermiso ? (
                <Outlet context={{ usuario }} />
            ) : (
                <Auth />
            )}
        </div>
    );
}
